import React, { useEffect, useRef, useState } from 'react';
import { default as __ } from '../utils';
import './input.css';

function Input({
  autofocus = false,
  initial,
  label,
  name,
  validation,
  ...otherProps
}) {
  const [ioValue, setIOValue] = useState(initial);
  const [ioValuekey, setIOValuekey] = useState(name);
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState(false);

  const inputRef = useRef();

  useEffect(() => {
    if (autofocus) inputRef.current.focus();
  }, []);

  useEffect(() => {
    setIOValue(initial);
  }, [initial]);

  useEffect(() => {
    if (!touched) return;
    if (validation) {
      validation
        .validate(ioValue)
        .then(_ => {
          // eslint-disable-line
          setError(false);
          onUpdate(ioValuekey, ioValue);
        })
        .catch(ValidationError => {
          setError({
            type: ioValuekey,
            msg: ValidationError.message,
          });
        });
    } else {
      onUpdate(ioValuekey, ioValue);
    }
  }, [ioValue]);

  const onChangeUpdate = e => {
    e.persist();

    setIOValue(e.target.value);
    setIOValuekey(e.target.name);
    if (!touched) {
      setTouched(true);
    }
  };
  const onPasteUpdate = e => {
    e.persist();
    const pasted = e.clipboardData.getData('text/plain');
    document.execCommand('insertHTML', false, pasted); // eslint-disable-line
  };

  const {
    autoComplete = 'off',
    onBlur = __.noop(),
    onFocus = __.noop(),
    onPaste = __.noop(),
    onUpdate,
    optional,
    server,
    type,
  } = otherProps;

  const inputLabel =
    typeof label === 'string' ? (
      <label htmlFor={name} io-input="label">
        <span>{label || name}</span>
        {optional && (
          <span
            style={{
              fontSize: '70%',
            }}
          >
            Optional
          </span>
        )}
      </label>
    ) : (
      label({
        value: ioValue,
        name: ioValuekey,
        label: label,
        touched,
        error,
        htmlFor: name,
      })
    );

  return (
    <div io-input="container">
      {inputLabel}

      <input
        ref={inputRef}
        value={ioValue}
        io-input="input"
        type={type}
        name={name}
        autoComplete={autoComplete}
        onChange={onChangeUpdate}
        onFocus={onFocus ? onFocus : __.noop()}
        onBlur={onBlur ? onBlur : __.noop()}
        onPaste={onPaste ? onPaste : onPasteUpdate}
      />

      {error && (
        <p io-input="error" aria-live="polite">
          {error.msg}
        </p>
      )}
      {server && (
        <p aria-live="polite" io-input="error">
          {server.msg}
        </p>
      )}
    </div>
  );
}

Input.displayName = 'IOInput';
export default Input;
